var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_history",
    d: "M20.562,10.544a10,10,0,0,1-16.276,7.8.967.967,0,0,1-.074-1.436l.454-.454a.969.969,0,0,1,1.286-.08A7.42,7.42,0,1,0,5.479,5.157L7.526,7.2a.645.645,0,0,1-.456,1.1H1.208a.645.645,0,0,1-.645-.645V1.8a.645.645,0,0,1,1.1-.456L3.655,3.332a10,10,0,0,1,16.908,7.212ZM13.268,13.72l.4-.509a.968.968,0,0,0-.17-1.358l-1.641-1.276V6.369a.968.968,0,0,0-.968-.968H10.24a.968.968,0,0,0-.968.968v5.47L11.91,13.89a.968.968,0,0,0,1.358-.17Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#212750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.7bad8184755c73b978b5fd6a289b4da2.svg";
export { ForwardRef as ReactComponent };